import { Stack } from '@mui/material'
import ContentBody from './ContentBody'
import ContentHeader from './ContentHeader'

export default function PageContent(){

    return(
        <Stack
            direction="column"
            spacing={2}
        >
            <ContentHeader/>
            <ContentBody/>

        </Stack>
    )

}
